import React from 'react';

import { Box } from '@mui/material';
import { selectBackgroundColor } from '@common/providers/ThemeProvider/selectors';

export default function SettingsWrapper({ children }) {
  return (
    <Box sx={{ p: 2, backgroundColor: selectBackgroundColor }}>{children}</Box>
  );
}
